import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/header';
import SidebarHeader from '../components/sidebarHeader';
import { useMediaQuery } from 'react-responsive';
import 'react-multi-carousel/lib/styles.css';
import PricingCard from '../components/PricingCard';
import Faq from '../components/Faq';
import Footer from '../components/Footer';
import { useSelector } from 'react-redux';
import pricing from '../assets/home/pricing.jpg';
import './styles.css';
import OneTimePricingCard from '../components/OneTimePricingCard';
import api from '../config/api';

const Price = () => {
  // State
  const [pack, setPack] = useState(false);

  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [data, setData] = useState(null);
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState("");
  const [packages, setPackages] = useState([]);
  const [packageError, setPackageError] = useState("");

  const isSignin = useSelector((state) => state.authReducer.issign);
  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );
  const userID = useSelector((state) => state.authReducer.uid);
  const userName = useSelector((state) => state.authReducer.name);
  const emails = useSelector((state) => state.authReducer.email);

  // Query
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1150px)',
  });
  const isLang = useSelector((state) => state.authReducer.lang);

  // Function
  const [menu, setMenu] = useState('');
  const handleMouseOver = (type) => {
    setMenu(type);
  };

  
  useEffect(() => {
    const fetchPackageData = async () => {
      try {
        const response = await fetch(`${api.API_URL}/aapi/getPackages.php`);
        if (!response.ok) {
          throw new Error("Failed to fetch categories");
        }
        const data = await response.json();
        setPackages(data);
      } catch (error) {
        setPackageError("Error fetching categories: " + error.message);
      }
    };

    fetchPackageData();
  }, []);

  if (isAuthenticated) {
    const api_url = `${api.API_URL}/aapi/getsubscription.php`;

    // Assuming you need to send some data along with the POST request
    const requestData = {
      user_id: userID,
      package_id: "1",
      duration: "5 Month",
      amount: "999",
      status: "on",
    };

    axios
      .post(api_url, requestData)
      .then((response) => {
        console.log("Response:", response.data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });

  } else {
    const api_url = `${api.API_URL}/aapi/getsubscription.php`;

    // Assuming you need to send some data along with the POST request
    const requestData = {
      user_id: userID,
      package_id: "1",
      duration: "5 Month",
      amount: "999",
      status: "on",
    };

    axios
      .post(api_url, requestData)
      .then((response) => {
        console.log("Response:", response.data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  console.log("package", packages);
  console.log("package", packages[0]?.title);
  console.log("categories", categories);



  return (
    <>
      {isDesktopOrLaptop ? (
        <Header menu={menu} setMenu={setMenu} />
      ) : (
        <SidebarHeader />
      )}
      <div onMouseOver={() => handleMouseOver('')} className="text-black">
        <section className="custon-section">
          <div className="custon-container">
            <p
              className="font-[600] text-[2.5rem] md:text-[32px] lg:text-[32px] text-center py-20"
              style={{ color: '#262b33', lineHeight: '3.5rem' }}
            >
              Why upgrade to Promotion Maker
            </p>
            <div className="custom-box-contianer">
              <div className="custom-box-one">
                <p
                  className="font-[200] text-[28px] mb-2"
                  style={{ fontFamily: 'poppins' }}
                >
                  Create with US
                </p>
                <p
                  className="text-[30px] font-[500] mb-2"
                  style={{ fontFamily: 'poppins' }}
                >
                  Design made even easier
                </p>
                <p
                  className="text-[16px]"
                  style={{ fontFamily: 'poppins' }}
                >
                  Craft professional content quickly.
                </p>
                <ul className="pl-4 list-disc list-outside">
                  <li className="leading-4 text-[16px] mt-6 mb-4">
                    Remove photo and video backgrounds in one click
                  </li>
                  <li className="leading-4 text-[16px] mb-4">
                    Unlimited access to photos, templates, graphics, and
                    videos
                  </li>
                  <li className="leading-4 text-[16px]">
                    Fix images fast with Magic Eraser.
                  </li>
                </ul>
              </div>
              <div
                className="custom-box-two"
                style={{
                  overflow: 'hidden',
                  background: 'red',
                  borderRadius: '14px',
                }}
              >
                <img src={`${pricing}`} alt="" />
              </div>
            </div>
          </div>
        </section>

       {/* Pricing Card */}
      <section style={{ maxWidth: "1400px", margin: "auto" }}>
          <div className="mt-[60px]  text-[#262b33]">
            {
              <p className="text-center font-[600] text-[28px] ">
                A perfect fit for everyone
              </p>
           }
            <div className="flex justify-center mt-[25px]  ">
              {isLang !== "esdfng" ? (
                <p
                  style={{
                    width: "clamp(300px,100%, 800px)",
                    textAlign: "center",
                    color: "#2b2b2b",
                  }}
                >
                  Elevate your marketing without financial stress. Maker4U
                  offers flexible pricing plans adjustable to businesses of all
                  sizes. Choose the plan that aligns with your ambitions and
                  witness your promotions mount to new heights.
                </p>
              ) : (
                <p
                  style={{
                    width: "clamp(300px,100%, 800px)",
                    textAlign: "center",
                    fontSize: "16px",
                  }}
                >
                  ارفع مستوى تسويقك دون ضغوط مالية. يقدم Maker4U خطط تسعير مرنة
                  قابلة للتعديل لتناسب الشركات بجميع أحجامها. اختر الخطة التي
                  تتوافق مع طموحاتك وشاهد عروضك الترويجية تصل إلى آفاق جديدة.
                </p>
              )}
            </div>
          </div>
          <div className="border-[1px] w-[320px] flex h-[60px] rounded-[12px] shadow-md p-[6px] mt-14 mb-10 m-auto ">
            <div
              style={{
                background:
                  pack === false
                    ? "#9333EA"
                    : "",
                color: pack === false ? "white" : "black",
              }}
              className={`  ${
                isLang === "esdfng" ? "" : "text-[22px] font-[600]"
              } w-[50%]  flex justify-center items-center rounded-md cursor-pointer`}
              onClick={() => setPack(false)}
            >
              {isLang !== "esdfng" ? "Monthly" : "شهريا"}
            </div>
            <div
              style={{
                background: pack
                  ? "#9333EA"
                  : "",
                color: pack ? "white" : "black",
              }}
              className={`  ${
                isLang === "esdfng" ? "" : "text-[22px] font-[600]"
              } w-[50%]  flex justify-center items-center rounded-md cursor-pointer`}
              onClick={() => setPack(true)}
            >
              {isLang !== "sdeng" ? "Yearly" : "سنوي"}
            </div>
          </div>

          <div className="flex justify-center gap-[15px] flex-wrap border-[rgba(57,76,96,.15)]">
  {pack === false ? (
    <>
      <PricingCard
        color={"#dedede"}
        hoverColor={"#f4f2f5"}
        text={"white"}
        title={isLang !== "arabic" ? `${packages[0]?.title}` : "حر"}
        desc={isLang !== "arabic" ? `${packages[0]?.title} Package` : "حزمة مجانية"}
        price={`${packages[0]?.price}`}
        packageId={"1"}
        duration="month"
        features={
          isLang !== "arabic"
            ? ["Free Templates"]
            : ["قوالب مجانية"] // Features in Arabic
        } // Pass features as props
      />
      <PricingCard
        color={"HSLA(0,100%,66%,1)"}
        hoverColor={"#fc4444"}
        text={"white"}
        title={isLang !== "arabic" ? `${packages[1]?.title}` : "عمل"}
        desc={isLang !== "arabic" ? `${packages[1]?.title} Plan` : "خطة عمل"}
        price={`${packages[1]?.price}`}
        packageId={"2"}
        duration="month"
        features={
          isLang !== "arabic"
            ? ["Free Templates", "Business Templates"]
            : ["قوالب مجانية", "قوالب الأعمال"] // Features in Arabic
        } // Pass features as props
      />
      <PricingCard
        color={"#7731D8"}
        hoverColor={"#612dae"}
        text={"white"}
        title={isLang !== "arabic" ? `${packages[2]?.title}` : "غالي"}
        desc={isLang !== "arabic" ? `${packages[2]?.title} Plan` : "الخطة المميزة"}
        price={`${packages[2]?.price}`}
        packageId={"3"}
        duration="month"
        features={
          isLang !== "arabic"
            ? ["Free Templates", "Business Templates", "Premium Templates"]
            : ["قوالب مجانية", "قوالب الأعمال", "قوالب مميزة"] // Features in Arabic
        } // Pass features as props
      />
    </>
  ) : (
    <>
      <PricingCard
        color={"#dedede"}
        hoverColor={"#f4f2f5"}
        text={"white"}
        title={isLang !== "arabic" ? `${packages[0]?.title}` : "حر"}
        desc={isLang !== "arabic" ? `${packages[0]?.title} Package` : "حزمة مجانية"}
        price={`${packages[0]?.yprice}`}
        packageId={"1"}
        duration="year"
        features={
          isLang !== "arabic"
            ? ["Free Templates"]
            : ["قوالب مجانية"] // Features in Arabic
        } // Pass features as props
      />
      <PricingCard
        color={"HSLA(0,100%,66%,1)"}
        hoverColor={"#fc4444"}
        text={"white"}
        title={isLang !== "arabic" ? `${packages[1]?.title}` : "عمل"}
        desc={isLang !== "arabic" ? `${packages[1]?.title} Plan` : "خطة عمل"}
        price={`${packages[1]?.yprice}`}
        packageId={"2"}
        duration="year"
        features={
          isLang !== "arabic"
            ? ["Free Templates", "Business Templates"]
            : ["قوالب مجانية", "قوالب الأعمال"] // Features in Arabic
        } // Pass features as props
      />
      <PricingCard
        color={"#7731D8"}
        hoverColor={"#612dae"}
        text={"white"}
        title={isLang !== "arabic" ? `${packages[2]?.title}` : "غالي"}
        desc={isLang !== "arabic" ? `${packages[2]?.title} Plan` : "الخطة المميزة"}
        price={`${packages[2]?.yprice}`}
        packageId={"3"}
        duration="year"
        features={
          isLang !== "arabic"
            ? ["Free Templates", "Business Templates", "Premium Templates"]
            : ["قوالب مجانية", "قوالب الأعمال", "قوالب مميزة"] // Features in Arabic
        } // Pass features as props
      />
    </>
  )}
</div>

          {isLang !== "asdeng" ? (
            <p className="text-[18px] text-center font-[500] mt-24 mb-16 text-black">
              <span className="text-[#0085FF] ">Our Subscribers</span> can enjoy
              premium Promotional Maker features for free
            </p>
          ) : (
            <p className="text-[18px] text-center font-[500] mt-24 mb-16 text-black">
              <span className="text-[#0085FF] "> يمكن للمشتركين </span> لدينا
              الاستمتاع بميزات صانع العروض الترويجية المتميزة مجانًا
            </p>
          )}
        </section>

        <section className="my-20">
          <Faq />
        </section>
        <footer>
          <Footer />
        </footer>
      </div>
    </>
  );
};

export default Price;
